import type { AbilityClass } from '@casl/ability'
import { Ability } from '@casl/ability'

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage' | 'view'

export type Subjects =
  | 'Auth'
  | 'Case'
  | 'Opportunity'
  | 'Funder'
  | 'Program'
  | 'Provider'
  | 'Patient'
  | 'AdminTools'
  | 'VerificationSession'
  | 'DiscoverySession'
  | 'BillingItem'
  | 'InsuranceInbox'
  | 'User'
  | 'ProviderReport'
  | 'SsdiProduct'
  | 'all'

export type AppAbility = Ability<[Actions, Subjects]>

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppAbility = Ability as AbilityClass<AppAbility>

export interface UserAbility {
  action: Actions
  subject: Subjects
}
